import { Navigate } from "react-router-dom"
import { useGlobal } from "@/app/store/global"
import { motion } from "framer-motion"
import { SecondaryButton } from "@/shared/ui/secondary-button.tsx"

interface IProps {
  withoutAction?: boolean
}

export const NotFound = ({ withoutAction = false }: IProps) => {
  const isAuthorized = useGlobal(useGlobal.selectAuthState)
  if (!isAuthorized) return <Navigate to="/" />

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-background px-4 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center space-y-6"
      >
        <h1 className="glitch text-[120px] font-extrabold leading-none text-gray-800 dark:text-gray-100">404</h1>
        <p className="text-xl font-medium text-gray-600 dark:text-gray-400">The page you're looking for doesn’t exist.</p>

        {!withoutAction && (
          <SecondaryButton className="mt-4 bg-zinc-200" onClick={() => window.location.replace("/")}>
            Go to Home
          </SecondaryButton>
        )}
      </motion.div>
    </div>
  )
}
